import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class PortfolioService {
  private apiUrl = 'https://alphurious.com/api/ContactUs/add';

  constructor(private http: HttpClient) {}

  submitContact(data: any): Observable<any> {
    return this.http.post(this.apiUrl, data);
  }
}
